import { ALL_OPTION, REGION_OPTIONS } from '@/routes/map/SitesMapPage.provinces'
import type { SiteMapFilterOptions, SiteMapFilters } from '@/routes/map/SitesMapPage.types'
import { Button } from 'devextreme-react/button'
import { CheckBox } from 'devextreme-react/check-box'
import { SelectBox, type SelectBoxTypes } from 'devextreme-react/select-box'

type SitesMapFiltersProps = {
  filters: SiteMapFilters
  options: SiteMapFilterOptions
  onChange: (changes: Partial<SiteMapFilters>) => void
  onReset: () => void
  onClose: () => void
}

type FilterSelectProps = {
  id: string
  label: string
  items: string[]
  value: string
  onChange: (value: string) => void
  searchEnabled?: boolean
  onCustomItemCreating?: (e: SelectBoxTypes.CustomItemCreatingEvent) => void
}

const FilterSelect = ({ id, label, onChange, onCustomItemCreating, ...selectProps }: FilterSelectProps) => (
  <div className={'sites-map-filters__field'}>
    <label htmlFor={id}>{label}</label>
    <SelectBox
      {...selectProps}
      inputAttr={{ id }}
      acceptCustomValue={Boolean(onCustomItemCreating)}
      onCustomItemCreating={onCustomItemCreating}
      onValueChanged={(e) => onChange(e.value)}
      stylingMode={'outlined'}
    />
  </div>
)

const SitesMapFiltersPanel = ({ filters, options, onChange, onReset, onClose }: SitesMapFiltersProps) => (
  <div className={'sites-map-filters'}>
    <div className={'sites-map-filters__header'}>
      <h3>Filtri Ricerca</h3>
      <Button icon={'close'} stylingMode={'text'} onClick={onClose} />
    </div>

    <FilterSelect
      id={'sites-map-region'}
      label={'Regione'}
      items={REGION_OPTIONS}
      value={filters.region}
      onChange={(region) => onChange({ region, province: ALL_OPTION, city: ALL_OPTION })}
      searchEnabled
    />
    <FilterSelect
      id={'sites-map-province'}
      label={'Provincia'}
      items={options.provinces}
      value={filters.province}
      onChange={(province) => onChange({ province, city: ALL_OPTION })}
      searchEnabled
    />
    <FilterSelect
      id={'sites-map-city'}
      label={'Comune / Città'}
      items={options.cities}
      value={filters.city}
      onChange={(city) => onChange({ city })}
      searchEnabled
      onCustomItemCreating={(e) => {
        const city = e.text?.trim() ?? ''
        if (city) onChange({ city })
        e.customItem = city
      }}
    />
    <FilterSelect
      id={'sites-map-relationship'}
      label={'Tipo Rapporto'}
      items={options.relationshipTypes}
      value={filters.relationshipType}
      onChange={(relationshipType) => onChange({ relationshipType })}
    />
    <FilterSelect
      id={'sites-map-agent'}
      label={'Agente'}
      items={options.agents}
      value={filters.agent}
      onChange={(agent) => onChange({ agent })}
      searchEnabled
    />

    <CheckBox
      text={'Solo sedi principali'}
      value={filters.onlyMainSites}
      onValueChanged={(e) => onChange({ onlyMainSites: e.value })}
    />

    <div className={'sites-map-filters__actions'}>
      <Button text={'Reset'} stylingMode={'outlined'} onClick={onReset} />
      <Button text={'Applica'} type={'default'} onClick={onClose} />
    </div>
  </div>
)

export default SitesMapFiltersPanel
